import * as React from 'react';
import * as styles from './Section.css';

export const Section: React.FC = ({ children }) => {
  return <div className={styles['section']}>{children}</div>;
};
